<div class="General efile-page m-4 p-4">
  <h1>Online Submission Status</h1>
  <div class="mb-1" style="text-align: right;">
    <p *ngIf="fileItems" class="efile-header" style="color: #043c5a">Welcome {{ userInfo.lastName }}, {{ userInfo.firstName }} {{ userInfo.middleName }}</p>
  </div>
  <br>

  <div *ngIf="!fileItems" class="p-2" style="display: flex; align-items: center; justify-content: center; flex-direction: column">
    <app-loading-spinner></app-loading-spinner>
    <p style="color: black; margin-top: 10px">Retrieving your submissions...</p>
  </div>

  <div *ngIf="fileItems" class="status-group">
    <div class="table-wrapper" >
      <table class="table">
        <thead class="header-mobile-label">
          <tr>
            <th scope="col">DATE</th>
            <th scope="col">WORK UNIT ID</th>
            <th scope="col">SUBMISSION ID</th>
            <th scope="col">FORM NAME / #</th>
            <th scope="col">AIN</th>
            <th scope="col">STATUS</th>
          </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of forms">
              <td><span class="mobile-label">DATE: </span> {{ item.date }}</td>

              <td><span class="mobile-label">WORK UNIT ID: </span> {{ getWorkUnitNumber(item) }}</td>
              <td><span class="mobile-label">SUBMISSION ID: </span> {{ item.id }}</td>
              <td><span class="mobile-label">FORM NAME / #: </span> {{item.fileName}} <br> {{item.description}}</td>
              <td><span class="mobile-label">AIN: </span> {{item.ain}}</td>

              <td *ngIf="shouldShowWUStart && item.workUnitId === 0; else wuStatusColumn">
                <button class="btn btn-primary btn-assessor" (click)="manuallyKickOffWorkUnit(item)">{{getCompleteButtonText(item)}}</button>
              </td>
              <ng-template #wuStatusColumn>
                <td *ngIf="item.status == 'Pending Signature'"><span class="mobile-label">STATUS: </span> <a (click)="accessLink(item.id)" style="color: blue">{{item.status}}</a></td>
                <td *ngIf="item.status != 'Pending Signature'"><span class="mobile-label">STATUS: </span> {{ item.status }}</td>
              </ng-template>
            </tr>

        </tbody>
      </table>
    </div>

    <div class="accordion">
      <accordion [isAnimated]="true">
        <accordion-group #drop9 [isOpen]="true">
          <div accordion-heading>
              <span class="dropdown-item clearfix">
                STATUS LEGEND
                <i
                  class="mt-1 float-end"
                  [ngClass]="!drop9.isOpen ? 'fas fa-plus' : 'fas fa-minus'"
                ></i>
              </span>
          </div>
          <div  style="border: 1px" class="w-100 legend">
            <p *ngFor="let item of legendItems">
              <span style="color: #3165b1">{{item.name}}:</span> {{item.description}}
            </p>
          </div>

        </accordion-group>
      </accordion>
    </div>

    <div class="status-pagination-controls">
      <select class="form-select" style="width: auto" [(ngModel)]="pageSize" (ngModelChange)="refreshForms()">
        <option [ngValue]="10">10 items per page</option>
        <option [ngValue]="20">20 items per page</option>
        <option [ngValue]="50">50 items per page</option>
      </select>

      <ngb-pagination [collectionSize]="collectionSize"
                      [(page)]="page"
                      [pageSize]="pageSize"
                      (pageChange)="refreshForms()"
                      [rotate]="true"
                      [ellipses]="false"
                      [boundaryLinks]="true"
                      [maxSize]="3">
      </ngb-pagination>
    </div>
  </div>

</div>
